import React, { useEffect, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowsRotate,faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios'
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/plugins/monthSelect/style.css";
import monthSelectPlugin from "flatpickr/dist/plugins/monthSelect";
import { TimeRangePickerProps } from 'antd';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';

import SAISVG from '../../../../_template/helpers/CommonFunction';

import ContactRequest from './contactRequest/ContactRequest';
import DemoRequest from './demoRequest/DemoRequest';

import { PageTitle } from '../../../../_template/layout/core/PageData';


const { RangePicker } = DatePicker;
const rangePresets: TimeRangePickerProps['presets'] = [
    { label: 'Last 7 Days', value: [dayjs().add(-7, 'd'), dayjs()] },
    { label: 'Last 14 Days', value: [dayjs().add(-14, 'd'), dayjs()] },
    { label: 'Last 30 Days', value: [dayjs().add(-30, 'd'), dayjs()] },
    { label: 'Last 90 Days', value: [dayjs().add(-90, 'd'), dayjs()] },
];

const ReceivedRequest = () => {

    const pageTitle = [
        {
            title: 'Dashboard',
            path: '/system-admin/dashboard',
            isSeparator: false,
            isActive: false,
        },
        {
            title: '',
            path: '',
            isSeparator: true,
            isActive: false,
        },
    ];

    const loginUserType = localStorage.getItem('type');
    const api_base_url = process.env.REACT_APP_API_URL;

    // ----- define all staet here ----- //
    const [tabType, setTabType] = useState('contact_request');
    const [dateState, setDateState] = useState({
        startDate: dayjs().subtract(29, 'day').startOf('day'),
        endDate: dayjs().endOf('day')
    });
    const [searchData, setSearchData] = useState({
        searchInput: '',
        startDate: '',
        endDate: '',
        tabType: tabType,
        isSearch: false
    });
    const [searchButtonLoader, setSearchButtonLoader] = useState(false);

    const [contactRequestNewCnt, setContactRequestNewCnt] = useState('0');
    const [demoRequestNewCnt, setDemoRequestNewCnt] = useState('0');


    const onRangeChange = (dates, dateStrings) => {
        if (dates) {
            setDateState((prevState)=>{
                return {
                    ...prevState,
                    startDate: dates[0],
                    endDate: dates[1]
                }
            })
        } else {
            setDateState((prevState)=>{
                return {
                    ...prevState,
                    startDate: null,
                    endDate: null
                }
            })
        }
    };
    const searchOnCLick = () => {
        setSearchButtonLoader(true)
        const formattedStartDate = dayjs(dateState.startDate).format('YYYY-MM-DD HH:mm:ss');
        const formattedEndDate = dayjs(dateState.endDate).format('YYYY-MM-DD HH:mm:ss');
        setSearchData(prev => ({
            ...prev,
            startDate: formattedStartDate,
            endDate: formattedEndDate,
            isSearch: true,
            tabType: tabType
        }));
    }

    // ------- get unread count value ------- //
    const getunreadCountValue = async () => {
        let apiToken = '';
        if(loginUserType === 'A'){
            apiToken = localStorage.getItem('token')
        }
        else if(loginUserType === 'D'){
            apiToken = localStorage.getItem('developertoken')
        }
        else if(loginUserType === 'SA') {
            apiToken = localStorage.getItem('systemAdminToken')
        }
        var api_headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "x-access-token" : apiToken
            }
        };
        await axios.post(`${api_base_url}api/get-unread-count-value`, {}, api_headers)
        .then(async (res) => {
            if(res.data.status === 'success') {
                var cntData = res.data.data;
                setContactRequestNewCnt(cntData.contact_info_cnt[0].count)
                setDemoRequestNewCnt(cntData.demo_request[0].count)
            } else if(res.data.status === 'error') {
                console.error('error')
            }
        })
        .catch((error) => {
            console.error(error);
        })
    }
    useEffect(() => {
        getunreadCountValue();
    },[tabType]);
    return (
        <>
            <style>
                {`
                    .tab-active {
                        border-bottom: 4px solid #0056b3;
                        color: #0056b3
                    }
                `}
            </style>
            <PageTitle breadcrumbs={pageTitle}>Received Request</PageTitle>
            <div className='row mb-5'>
                <div className='col-md-12'>
                    <div className='card card-rounded border'>
                        <div className="card-header">
                            <h3 className="card-title align-items-start flex-column">
                                <span className="card-label fw-bold text-dark d-flex">
                                    <li 
                                        className="nav-item mt-2 text-hover-primary cursor-pointer"
                                        onClick={() => setTabType('contact_request')}
                                    >
                                        <div className={`nav-link ms-0 me-10 py-5 ${tabType === 'contact_request'? 'tab-active' : 'text-gray-600'}`}>
                                            Contact request
                                            {
                                                contactRequestNewCnt !== '0' &&
                                                <span 
                                                    className="badge badge-primary badge-lg ms-3 badge-square"
                                                >
                                                    {contactRequestNewCnt}
                                                </span>
                                            }
                                        </div>
                                    </li>
                                    <li 
                                        className="nav-item mt-2 cursor-pointer text-hover-primary"
                                        onClick={() => {
                                            setTabType('demo_request')
                                        }}
                                    >
                                        <div className={`nav-link ms-0 py-5 ${tabType === 'demo_request' ? 'tab-active' : 'text-gray-600'}`}>
                                            Demo request
                                            {
                                                demoRequestNewCnt !== '0' &&
                                                <span 
                                                    className="badge badge-primary badge-lg ms-3 badge-square"
                                                >
                                                    {demoRequestNewCnt}
                                                </span>
                                            }
                                        </div>
                                    </li>
                                </span>
                            </h3>
                            <div className="card-toolbar">
                                <div className="d-flex flex-stack flex-wrap gap-0">
                                    <div className="position-relative me-2 m-w-100">
                                        <div className="input-group">
                                            <input 
                                                type="text" 
                                                className="form-control w-350px" 
                                                placeholder="Search by name, email or phone no"
                                                onChange={(e) => (
                                                    setSearchData(prev => ({
                                                        ...prev,
                                                        searchInput: e.target.value
                                                    }))
                                                )}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="d-flex flex-stack flex-wrap gap-0">
                                    <div className="position-relative me-2 m-w-100">
                                        <RangePicker
                                            presets={[
                                                {
                                                    label: <span aria-label="Current Time to End of Day">To day</span>,
                                                    value: () => [dayjs().startOf('day'), dayjs().endOf('day')],
                                                },
                                                ...rangePresets,
                                            ]}
                                            defaultValue={[dateState.startDate, dateState.endDate]}
                                            format="YYYY-MM-DD"
                                            onChange={onRangeChange}
                                            allowClear={false}
                                        />
                                    </div>
                                </div>
                                <div
                                    className="btn btn-warning btn-icon"
                                    onClick={searchOnCLick}
                                >
                                    {
                                        searchButtonLoader ? 
                                        <FontAwesomeIcon icon={faArrowsRotate} className='fa-spin' />
                                        :
                                        <FontAwesomeIcon icon={faMagnifyingGlass} />
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='row'>
                <div className='col-md-12'>
                    {
                        tabType === 'contact_request' &&
                        <ContactRequest
                            searchData={searchData}
                            isRefresh={() => {
                                setSearchData(prev => ({
                                    ...prev,
                                    searchInput: '',
                                    startDate: '',
                                    endDate: '',
                                    isSearch: false
                                }));
                                setSearchButtonLoader(false);
                                getunreadCountValue();
                            }}
                        />
                    }
                    {
                        tabType === 'demo_request' &&
                        <DemoRequest
                            searchData={searchData}
                            isRefresh={() => {
                                setSearchData(prev => ({
                                    ...prev,
                                    searchInput: '',
                                    startDate: '',
                                    endDate: '',
                                    isSearch: false
                                }));
                                setSearchButtonLoader(false);
                                getunreadCountValue();
                            }}
                        />
                    }
                </div>
            </div>
        </>
    )
}

export default ReceivedRequest